import Box from '../Box'

export interface PressableProps {
  onClick?: () => void
}

const Pressable: RFC<PressableProps> = ({ onClick, children }) => {
  return <Box onClick={onClick}>{children}</Box>
}

export default Pressable
